<script setup lang="ts">import { computed as _computed } from 'vue';


import IconComponent from '@toolify/client/src/modules/ui/components/IconComponent.vue'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {IconWeightType} from '@toolify/client/src/modules/ui/enum/IconWeightType'
import {IAgentResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IAgentResponseInstance'
import {IResponseEntity} from '@toolify/server/src/services/EntityService/types/IResponseEntity'

interface Props {
  payload: {
    entity?: IResponseEntity | null
    agent?: IAgentResponseInstance | null
  }
  entityId: string
}

const props = withDefaults(defineProps<Props>(), {
  payload: () => ({}),
})

const agentData = _computed<(IAgentResponseInstance & {completedIconFileVariants?: Array<{url: string}>}) | null>(() => {
  if(props.payload?.entity?.payload) {
    return props.payload.entity.payload as IAgentResponseInstance
  }
  return props.payload?.agent ?? null
})

function initial(name?: string, id?: string): string {
  const s = ((name || id) ?? 'A').trim()
  return s.slice(0, 1).toUpperCase()
}
</script>

<template>
  <div class="agent-permission-entity-thumb">
    <img
      v-if="agentData?.completedIconFileVariants?.[0]?.url"
      :src="agentData.completedIconFileVariants[0].url"
      :alt="agentData.title || agentData.name || ''"
      class="agent-permission-entity-thumb-image"
    />
    <IconComponent
      v-else-if="!agentData?.title && !agentData?.name"
      :name="IconNameType.Robot"
      :weightType="IconWeightType.Solid"
      class="agent-permission-entity-thumb-icon"
    />
    <span v-else class="agent-permission-entity-thumb-letter">
      {{initial(agentData?.title || agentData?.name, entityId)}}
    </span>
  </div>
</template>

<style scoped lang="scss">
@use '../../../../styles/variables' as variables;

.agent-permission-entity-thumb {
  background-color: map-get(variables.$colors, container-high);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.31rem;
  aspect-ratio: 1/1;
  border-radius: map-get(variables.$radiuses, radius-full);
  overflow: hidden;
}

.agent-permission-entity-thumb-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: map-get(variables.$spacing, space-1);
}

.agent-permission-entity-thumb-icon {
  width: 65% !important;
  height: 65% !important;
  color: map-get(variables.$colors, content-dim);

  :deep(.icon-content) {
    width: 100%;
    height: 100%;
  }
}

.agent-permission-entity-thumb-letter {
  font-size: map-get(variables.$textSizes, text-2xs);
  font-weight: 700;
  line-height: 1;
  color: map-get(variables.$colors, content-bright);
}
</style>
